module.exports = __webpack_public_path__ + "static/img/szyyy.1f0a16da.png";